export default __webpack_public_path__ + "static/media/lead-capture.a4e12eeb.jpg";